import { camelCase } from 'lodash';
import { groupBy, lensPath, set, view } from 'ramda';
import { CUSTOM_CATEGORY } from 'spw-constants';
import {
  CropZoneRect,
  EditAction,
  EditCommand,
  ISpace,
} from 'spw-redux/modules/floorplan/types';

export const compressEditHistory = (commands: EditCommand[]) => {
  const compressedHistory: EditCommand[] = [];

  commands.forEach((command) => {
    if (!compressedHistory.length) {
      compressedHistory.push(command);
    } else {
      const lastItemIndex = compressedHistory.length - 1;
      const lastItem = compressedHistory[lastItemIndex];
      if (
        lastItem.action === EditAction.Crop &&
        command.action === EditAction.Crop
      ) {
        const data = {
          height: command.data.height,
          width: command.data.width,
          top:
            (lastItem.data as CropZoneRect).top +
            (command.data as CropZoneRect).top,
          left:
            (lastItem.data as CropZoneRect).left +
            (command.data as CropZoneRect).left,
        } as CropZoneRect;

        compressedHistory[lastItemIndex].data = data;
      } else {
        compressedHistory.push(command);
      }
    }
  });

  return compressedHistory;
};

export const spaceCategoryPath = lensPath([
  'projectSpaceType',
  'category',
  'defaultSpaceTypeCategory',
  'category',
]);

export const otherSpaceCategoryPath = lensPath([
  'spaceType',
  'spaceTypeCategory',
  'category',
]);

export const buildSpacesMap = (floorSpaces: ISpace[]) => {
  const spaces: ISpace[] = floorSpaces.map((s: ISpace) => {
    if (camelCase(s.spaceType.spaceTypeCategory.category) === CUSTOM_CATEGORY) {
      return {
        ...set(
          otherSpaceCategoryPath,
          camelCase(view(otherSpaceCategoryPath, s)),
          s
        ),
        usf: s.usf,
      };
    }

    return {
      ...set(spaceCategoryPath, camelCase(view(spaceCategoryPath, s)), s),
      usf: s.usf,
    };
  });

  const spacesGroupedByCategory = groupBy((space: ISpace) => {
    if (space.spaceType.spaceTypeCategory.category === CUSTOM_CATEGORY) {
      return view(otherSpaceCategoryPath, space);
    }

    return view(spaceCategoryPath, space);
  }, spaces);

  return {
    spacesMap: new Map(Object.entries(spacesGroupedByCategory)),
    spacesGroupedByCategory,
  };
};
